import React, { Component } from "react";

import {
    MDBBtn,
    MDBSpinner,
    MDBModal,
    MDBModalHeader,
    MDBModalBody,
    MDBModalFooter,
    MDBIcon,
    toast,
} from "mdbreact";

import SuppressedDevicesTable from "../../../components/NetworkMgmt/Venues/Datatables/SuppressedDevicesTable";

import { withTranslation } from "react-i18next";

import axios from "../../../axios";

class ViewSuppressedDevices extends Component {
    constructor(props) {
        super(props);
        this.state = {
            suppressedDevices: undefined,
            loadingSuppressedDevices: false,
            modalClearSuppression: false,
            clearingSuppression: false,
            selectedMacs: [],
            disabled:
                sessionStorage.getItem("customerSupport") > 0 ? true : false,
        };
    }

    componentDidMount() {
        // TEMP: test with sample data instead of the API.
        // Revert this block (re-enable this.getSuppressedDevices()) before committing.
        // this.setState({
        //     suppressedDevices: {
        //         longterm: [
        //             { mac: "aa920ba92459", count: 7, ttl: 33977 },
        //             { mac: "82abed5a7788", count: 4, ttl: 25507 },
        //         ],
        //         repeat: [],
        //         short: [],
        //     },
        //     loadingSuppressedDevices: false,
        // });
        this.getSuppressedDevices();
    }

    componentDidUpdate(prevProps) {
        // Refresh the flagged devices table when the selected venue changes.
        if (prevProps.venueID !== this.props.venueID) {
            this.setState({ selectedMacs: [] });
            this.getSuppressedDevices();
        }
    }

    getSuppressedDevices = () => {
        this.setState({ loadingSuppressedDevices: true });

        let body = {
            AccessToken: sessionStorage.getItem("AccessToken"),
            IdToken: sessionStorage.getItem("IdToken"),
            VenueID: this.props.venueID,
        };

        axios
            .post("/operatorconsole/venues/listSuppressedDevices", body, {
                headers: { "api-version": "20260417" },
            })
            .then((response) => {
                this.setState({
                    suppressedDevices:
                        response.data.suppressed ||
                        response.data.SuppressedDevices ||
                        response.data.SuppressedMacs ||
                        response.data.suppressedDevices ||
                        response.data.Devices ||
                        {},
                    loadingSuppressedDevices: false,
                });
            })
            .catch((error) => {
                toast.error(
                    error?.response?.data?.message ||
                        "There was an error loading suppressed devices!",
                    {
                        closeButton: false,
                    }
                );
                this.setState({
                    suppressedDevices: [],
                    loadingSuppressedDevices: false,
                });
            });
    };

    toggleClearSuppression = () => {
        this.setState({
            modalClearSuppression: !this.state.modalClearSuppression,
        });
    };

    handleSelectionChange = (selectionModel, selectedRows) => {
        this.setState({
            selectedMacs: selectedRows.map((row) => row.mac),
        });
    };

    clearSuppressionList = async () => {
        const macs = this.state.selectedMacs || [];
        if (macs.length === 0) {
            return;
        }

        this.setState({ clearingSuppression: true });

        let successCount = 0;
        let errorCount = 0;

        // Send one request per selected MAC, one at a time.
        for (const mac of macs) {
            let body = {
                AccessToken: sessionStorage.getItem("AccessToken"),
                IdToken: sessionStorage.getItem("IdToken"),
                VenueID: this.props.venueID,
                clearSuppressedMacs: true,
                "Calling-Station-Id": mac,
            };

            try {
                await axios.post(
                    "/networkoperatorconsole/venues/configureVenue",
                    body,
                    {
                        headers: { "api-version": "20260417" },
                    }
                );
                successCount++;
            } catch (error) {
                errorCount++;
                toast.error(
                    error?.response?.data?.message ||
                        `There was an error resetting ${mac}!`,
                    {
                        closeButton: false,
                    }
                );
            }
        }

        if (successCount > 0) {
            toast.success(
                `${successCount} device${
                    successCount === 1 ? "" : "s"
                } reset!`,
                {
                    closeButton: false,
                }
            );
        }

        this.setState({
            clearingSuppression: false,
            modalClearSuppression: errorCount > 0,
            selectedMacs: [],
        });
        this.getSuppressedDevices();
    };

    render() {
        const { suppressedDevices } = this.state;
        const countDevices = (data) => {
            if (!data) return 0;
            if (Array.isArray(data)) return data.length;
            // Categorized object (e.g. { longterm: [], repeat: [], short: [] })
            // or a plain object keyed by MAC.
            return Object.values(data).reduce((total, value) => {
                if (Array.isArray(value)) return total + value.length;
                return total + 1;
            }, 0);
        };
        const isEmpty = countDevices(suppressedDevices) === 0;

        return (
            <>
                <MDBModal
                    isOpen={this.state.modalClearSuppression}
                    toggle={this.toggleClearSuppression}
                    centered
                >
                    <MDBModalHeader toggle={this.toggleClearSuppression}>
                        Reset Selected Devices
                    </MDBModalHeader>
                    <MDBModalBody>
                        This will remove the {this.state.selectedMacs.length}{" "}
                        selected device
                        {this.state.selectedMacs.length === 1 ? "" : "s"} from the
                        suppression list and allow them to attempt to
                        re-authenticate. If devices continue to connect with an
                        invalid PSK, they will be added to the list again.
                    </MDBModalBody>
                    <MDBModalFooter>
                        <MDBBtn
                            color="danger"
                            onClick={this.clearSuppressionList}
                            disabled={this.state.clearingSuppression}
                        >
                            {this.state.clearingSuppression ? (
                                <div
                                    className="spinner-border spinner-border-sm"
                                    role="status"
                                >
                                    <span className="sr-only">Loading...</span>
                                </div>
                            ) : (
                                "Confirm"
                            )}
                        </MDBBtn>
                        <MDBBtn
                            color="primary"
                            onClick={this.toggleClearSuppression}
                            disabled={this.state.clearingSuppression}
                        >
                            Cancel
                        </MDBBtn>
                    </MDBModalFooter>
                </MDBModal>
                {this.state.loadingSuppressedDevices ? (
                    <MDBSpinner small />
                ) : (
                    <div className="servicePlans">
                        <SuppressedDevicesTable
                            suppressedDevices={suppressedDevices}
                            onSelectionChange={this.handleSelectionChange}
                        />
                    </div>
                )}
                <div className="text-right mt-3">
                    <MDBBtn
                        color="danger"
                        onClick={this.toggleClearSuppression}
                        disabled={
                            this.state.disabled ||
                            this.state.loadingSuppressedDevices ||
                            isEmpty
                        }
                    >
                        <MDBIcon icon="ban" className="mr-2" />
                        Reset Selected Devices
                    </MDBBtn>
                </div>
            </>
        );
    }
}

export default withTranslation()(ViewSuppressedDevices);
